import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import Translate from 'react-translate-component';
import { map, path, prop } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import {
    postApprovePerson,
    postRejectPerson,
    postApproveProject,
    postRejectProject,
    postCancelRequest,
    putApprovalApplication,
    postMetroRequestApproval,
} from 'actions/asyncActions';
import { modalPropTypes } from 'components/Modals';
import CommentForm from 'components/modals/approvals/CommentForm';
import { getFullName } from 'helpers/fieldsHelpers';

const mapFullName = map(getFullName);
const mapPosition = map(prop('position'));
const mapApplication = map(path(['parent', 'name']));

class ApprovalModal extends Component {
    static propTypes = {
        ...modalPropTypes,
        mapper: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        action: PropTypes.object.isRequired,
        required: PropTypes.bool
    };

    render() {
        const { modal, action, params, title, mapper, required, limit } = this.props;

        const header = <div><Translate content={`modal.${title}`}/></div>;

        return (
            <div>
                <Modal {...modal} title={header} footer={null}>
                    <CommentForm
                        title={title}
                        formAction={action}
                        params={params}
                        mapper={mapper}
                        required={required}
                        limit={limit}
                    />
                </Modal>
            </div>
        );
    }
}

const connectApprovalModal = (title, mapper, action, required, limit) => {
    const asynced = withAsyncActions(({ hide, remove, show }) => ({
        action: action
            .withPendingHandler(hide)
            .withSuccessHandler(remove)
            .withErrorHandler(show)
            .withOptions({ resetOnMount: true })
    }))(ApprovalModal);

    return connect(() => ({ title, mapper, required, limit }))(asynced);
}

export const ApprovePersonModal = connectApprovalModal('approve', mapFullName, postApprovePerson, false);
export const RejectPersonModal = connectApprovalModal('reject', mapFullName, postRejectPerson, true);

export const ApproveProjectModal = connectApprovalModal('approve', mapPosition, postApproveProject, false);
export const RejectProjectModal = connectApprovalModal('reject', mapPosition, postRejectProject, true);

export const CancelRequestModal = connectApprovalModal('cancel', mapPosition, postCancelRequest, true);

export const ApproveApplicationModal = connectApprovalModal('approve', mapApplication, putApprovalApplication, false);
export const CancelApplicationModal = connectApprovalModal('reject', mapApplication, putApprovalApplication, true);

export const MetroApproveApplicationModal = connectApprovalModal('approve', mapPosition, postMetroRequestApproval, false, 255);
export const MetroRejectApplicationModal = connectApprovalModal('reject', mapPosition, postMetroRequestApproval, false, 255);
export const MetroCancelApplicationModal = connectApprovalModal('annul', mapPosition, postMetroRequestApproval, false, 255);
